import { DataGrid } from "@mui/x-data-grid";
import { useHistory, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form } from "formik";

const InvoiceTable = (listOfInvoices) => {
  const [listOfActiveCores, setListOfActiveCores] = useState([]);
  const [showPopup, setShowPopup] = useState(false)
  const [archiveId, setArchiveId] = useState(false)

  let history = useHistory();
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
          let array = []
          let getValue = listOfInvoices
              Object.keys(getValue.listOfInvoices).map(function(keyName, keyIndex) {
                //if(getValue.listOfInvoices[keyIndex].chatRoomArchivedMessages != null){
                  let d = new Date( getValue.listOfInvoices[keyIndex].createdAt );
                  let date = d.toDateString();
                  let newObject = {}
                  newObject.id = keyIndex
                  newObject.createdOn = date
                  newObject.invoiceDetails = getValue.listOfInvoices[keyIndex].invoiceDetails
                  newObject.amount = "$" + (parseInt(getValue.listOfInvoices[keyIndex].amount)/100)
                  newObject.invoiceStatus = getValue.listOfInvoices[keyIndex].invoiceStatus
                  array.push(newObject);
                //}
            })
            setListOfActiveCores(array)
      }
    }, []);

  const userColumns = [
    {
      field: "createdOn",
      headerName: "Created on",
      width: 250,
      renderCell: (params) => {
        return (
          <div className={`cellWithStatus ${params.row.createdOn}`}>
            {params.row.createdOn}
          </div>
        );
      },
    },
    {
      field: "invoiceDetails",
      headerName: "Invoice Details",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
            {/*<img className="cellImg" src={params.row.img} alt="avatar" />*/}
            {params.row.invoiceDetails}
          </div>
        );
      },
    },
    {
      field: "amount",
      headerName: "Price",
      width: 250,
      renderCell: (params) => {
        return (
          <div className={`cellWithStatus ${params.row.amount}`}>
            {params.row.amount}
          </div>
        );
      },
    },
    {
      field: "invoiceStatus",
      headerName: "Invoice status",
      className: "test",
      width: 160,
      cellStyle: params => {
        if (params.row.invoiceStatus == "In progress") {
            return {color: 'red', backgroundColor: 'green'};
        }
      },
      renderCell: (params) => {
        return (
          <div className={`cellWithStatus ${params.row.invoiceStatus == "In progress" ? "in-progress" : "complete"}`}>
            {params.row.invoiceStatus}
          </div>
        );
      },
    },
  ];


  
  return (
    <div className="datatable">
        {showPopup ? 
          <PopupArchive archiveId={archiveId} stateChanger={setShowPopup}/>
        : ""}
      <DataGrid
        className="datagrid"
        rows={listOfActiveCores}
        columns={userColumns.map((col) => ({
          ...col,
          align: col.align ?? "center",
          headerAlign: col.headerAlign ?? "center",
        }))}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </div>
  );
};

const PopupArchive = ({archiveId, stateChanger}) => {
  const [leadPhoneNumber, setLeadPhoneNumber] = useState("")
  const [messageHistory, setMessageHistory] = useState([])
  function closePopup() {
    stateChanger(false)
  }
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/core-archives/byId/${archiveId}`).then((response) => {
      if(response.data.chatRoomArchivedMessages !== null){
          setMessageHistory((list) => [...list, response.data.chatRoomArchivedMessages]) 
      }
    })
  }, [])

  if(messageHistory){
  let test = '{ "data": {' + messageHistory + '}}'
  let value = JSON.parse(test.replaceAll('\\', '')) // 👉️ '123' 
  return(
        <div className='popup archive-popup-container'>
        <div className='popup_inner'>
        <h1>Core archive - {archiveId}</h1>
        <Formik>
            <Form>
                <div className="popup-content">
                  <div className="core-window">
                    <div className="core-body">
                      {value["data"] != undefined  ?
                          Object.entries(value["data"]).map(([key, val]) =>                 
                              <div className="message">
                                  <div>
                                      <div className="message-content">
                                          <p>{value["data"][key][0].message}</p>
                                      </div>
                                      <div className="message-meta">
                                          <p id="time">{value["data"][key][0].time}</p>
                                          <p id="author">{value["data"][key][0].author}</p>
                                      </div>
                                  </div>
                              </div>
                          )
                          : alert(value["data"][0])
                      }
                </div>
                  </div>

                    <div className="popup-button-group">
                        <button type="submit" className="popup-button popup-button-save">Save changes</button>
                        <button className="popup-button" onClick={closePopup}>Close popup</button>
                    </div>
                </div>
            </Form>
        </Formik>
        </div>
    </div>
    )
  }
}

export default InvoiceTable;
